import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createLocation } from 'API/Location/createLocation';

const useCreateLocation = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (locationData) => {
        const response = await createLocation(locationData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['Locations'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateLocation;
